import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dataFilterFormControl"
})

export class DataFilterFormControlPipe implements PipeTransform {

    transform(array: any[], query: string, name?: string): any {
        if (query) {
            if (name) {
                return _.filter(array, row => row.value[name].indexOf(query) > -1);
            }
            return _.filter(array, row => row.value.name.indexOf(query) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/data-filter-form-control.pipe.ts